import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    PayLatestInvoiceOnPastDueSubscriptionRequest, PayLatestInvoiceOnPastDueSubscriptionResponse,
    PreviewInvoicesForQuantityRequest, PreviewInvoicesForQuantityResponse,
    PreviewUpcomingInvoiceForBillingIntervalRequest, PreviewUpcomingInvoiceForBillingIntervalResponse
} from "./types";

export { apiName };

const previewUpcomingInvoiceForBillingInterval = getCallable<PreviewUpcomingInvoiceForBillingIntervalRequest, PreviewUpcomingInvoiceForBillingIntervalResponse>(
    apiName,
    "previewUpcomingInvoiceForBillingInterval",
    {
        ...endpoints.previewUpcomingInvoiceForBillingInterval,
        composer: request => {
            const searchParams = new URLSearchParams();
            searchParams.set("billingInterval", request.billingInterval);

            return {
                url: `/workspaces/${request.workspaceId}/billing/invoices/preview/billing-interval?${searchParams.toString()}`,
                options: {
                    method: "GET"
                }
            };
        }
    });

const previewInvoicesForQuantity = getCallable<PreviewInvoicesForQuantityRequest, PreviewInvoicesForQuantityResponse>(
    apiName,
    "previewInvoicesForQuantity",
    {
        ...endpoints.previewInvoicesForQuantity,
        composer: request => {
            const searchParams = new URLSearchParams();
            searchParams.set("quantity", request.quantity.toString());

            return {
                url: `/workspaces/${request.workspaceId}/billing/invoices/preview/quantity?${searchParams.toString()}`,
                options: {
                    method: "GET"
                }
            };
        }
    });

const payLatestInvoiceOnPastDueSubscription = getCallable<PayLatestInvoiceOnPastDueSubscriptionRequest, PayLatestInvoiceOnPastDueSubscriptionResponse>(
    apiName,
    "payLatestInvoiceOnPastDueSubscription",
    {
        ...endpoints.payLatestInvoiceOnPastDueSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/pay-latest-invoice`,
                options: {
                    method: "POST"
                }
            };
        }
    });

export const callables = {
    previewUpcomingInvoiceForBillingInterval,
    previewInvoicesForQuantity,
    payLatestInvoiceOnPastDueSubscription
};
